import { Modal } from 'antd';
import type { LocationImportResult } from '@/types/location';
import styles from '../../products/components/ProductImportResultModal.module.scss';

interface LocationImportResultModalProps {
  open: boolean;
  result: LocationImportResult | null;
  message?: string | null;
  onClose: () => void;
}

export function LocationImportResultModal({
  open,
  result,
  message,
  onClose,
}: LocationImportResultModalProps) {
  if (!result) return null;

  return (
    <Modal
      title="Import finished"
      open={open}
      onCancel={onClose}
      onOk={onClose}
      okText="Close"
      cancelButtonProps={{ style: { display: 'none' } }}
      width={560}
    >
      {message ? <p className={styles.summary}>{message}</p> : null}

      <div className={styles.stats}>
        <div>
          <strong>{result.created}</strong>
          <span>Created</span>
        </div>
        <div>
          <strong>{result.updated}</strong>
          <span>Updated</span>
        </div>
        <div>
          <strong>{result.failed}</strong>
          <span>Failed</span>
        </div>
      </div>

      {result.errors.length ? (
        <div className={styles.errors}>
          <p className={styles.errorsTitle}>Errors</p>
          <ul>
            {result.errors.map((error) => (
              <li key={`${error.row}-${error.message}`}>
                Row {error.row}: {error.message}
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </Modal>
  );
}
